function BaseContainerWrapper({ children }) {
  return (
    <div className="text-gray-700 w-full max-w-[850px] mx-auto mt-6">
      {children}
    </div>
  );
}

export default BaseContainerWrapper;
